import { render, staticRenderFns } from "./TEST_XZT.vue?vue&type=template&id=5238f320&scoped=true"
import script from "./TEST_XZT.vue?vue&type=script&lang=js"
export * from "./TEST_XZT.vue?vue&type=script&lang=js"
import style0 from "./TEST_XZT.vue?vue&type=style&index=0&id=5238f320&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5238f320",
  null
  
)

export default component.exports